/**
 * Testimonials Tabs with Swipers and Load More
 */

// Load More handler for testimonials page (unified CPT with taxonomy)
export function initTestimonialsLoadMore() {
    var loadMoreButtons = document.querySelectorAll('.btn-load-more[data-type]');
    
    if (loadMoreButtons.length === 0) return;
    
    // Get AJAX config from localized script
    var ajaxUrl = typeof testimonials_ajax !== 'undefined' ? testimonials_ajax.ajaxurl : '/wp-admin/admin-ajax.php';
    var pageNonce = typeof testimonials_ajax !== 'undefined' ? testimonials_ajax.page_nonce : '';
    
    loadMoreButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            
            var type = this.getAttribute('data-type');
            var currentPage = parseInt(this.getAttribute('data-page') || '1');
            var maxPages = parseInt(this.getAttribute('data-max-pages') || '1');
            var nextPage = currentPage + 1;
            
            if (nextPage > maxPages) return;
            
            // Determine container
            var containerId;
            switch(type) {
                case 'video-testimonials':
                    containerId = 'video-testimonials-container';
                    break;
                case 'client-reviews':
                    containerId = 'client-reviews-container';
                    break;
                case 'good-firms-reviews':
                    containerId = 'goodfirms-reviews-container';
                    break;
            }
            
            var container = document.getElementById(containerId);
            if (!container) return;
            
            // Show loading state
            var spinner = this.querySelector('.btn-spinner');
            var btnText = this.querySelector('.btn-text');
            if (spinner) spinner.style.display = 'inline-block';
            if (btnText) btnText.textContent = 'Loading...';
            this.disabled = true;
            
            var button = this;
            
            // AJAX request
            var formData = new FormData();
            formData.append('action', 'load_more_testimonials_page');
            formData.append('page', nextPage);
            formData.append('type', type);
            formData.append('nonce', pageNonce);
            
            fetch(ajaxUrl, {
                method: 'POST',
                body: formData
            })
            .then(function(response) { return response.json(); })
            .then(function(data) {
                if (data.success && data.data.html) {
                    // Create temp container for animation
                    var temp = document.createElement('div');
                    temp.innerHTML = data.data.html;
                    var items = temp.children;
                    var delay = 0;
                    
                    Array.from(items).forEach(function(item) {
                        item.style.opacity = '0';
                        item.style.transform = 'translateY(20px)';
                        item.style.transition = 'opacity 0.4s ease-out, transform 0.4s ease-out';
                        item.style.transitionDelay = delay + 'ms';
                        container.appendChild(item);
                        
                        setTimeout(function() {
                            item.style.opacity = '1';
                            item.style.transform = 'translateY(0)';
                        }, 10);
                        
                        delay += 100;
                    });
                    
                    // Update page number
                    button.setAttribute('data-page', nextPage);
                    
                    // Hide button if no more pages
                    if (nextPage >= maxPages) {
                        button.style.display = 'none';
                    }
                }
            })
            .catch(function(error) {
                console.error('Error:', error);
            })
            .finally(function() {
                // Reset button state
                if (spinner) spinner.style.display = 'none';
                if (btnText) btnText.textContent = 'Load More';
                button.disabled = false;
            });
        });
    });
}

export function initTestimonialsTabs() {
    var tabButtons = document.querySelectorAll('.testimonial-tab-btn');
    var tabContents = document.querySelectorAll('.testimonial-tab-content');
    var videoSwiper = null;
    var reviewsSwiper = null;

    if (tabButtons.length === 0) return;

    function initSwipersIfNeeded(tabType) {
        if (typeof Swiper === 'undefined') return;

        var swiperOptions = {
            a11y: { enabled: false },
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            autoplay: { delay: 4000, disableOnInteraction: false },
            speed: 800,
            breakpoints: {
                320: { slidesPerView: 1, spaceBetween: 20 },
                576: { slidesPerView: 1.5, spaceBetween: 20 },
                768: { slidesPerView: 2, spaceBetween: 30 },
                1024: { slidesPerView: 1.5, spaceBetween: 30 },
                1200: { slidesPerView: 2, spaceBetween: 30 }
            }
        };

        if (tabType === 'video' || !tabType) {
            var videoElement = document.querySelector('.video-testimonials-swiper');
            if (videoElement && !videoElement.swiper) {
                var parentTab = videoElement.closest('.testimonial-tab-content');
                if (parentTab && !parentTab.classList.contains('hidden')) {
                    videoSwiper = new Swiper('.video-testimonials-swiper', Object.assign({}, swiperOptions, {
                        navigation: { nextEl: '.video-testimonials-next', prevEl: '.video-testimonials-prev' },
                        pagination: {
                            el: '.video-testimonials-pagination',
                            clickable: true,
                            renderBullet: function(index, className) {
                                return '<span class="' + className + ' w-2 h-2 rounded-full bg-gray-300 cursor-pointer transition-colors duration-300"></span>';
                            }
                        }
                    }));
                }
            }
        }

        if (tabType === 'reviews' || !tabType) {
            var reviewsElement = document.querySelector('.client-reviews-swiper');
            if (reviewsElement && !reviewsElement.swiper) {
                var parentTab = reviewsElement.closest('.testimonial-tab-content');
                if (parentTab && !parentTab.classList.contains('hidden')) {
                    reviewsSwiper = new Swiper('.client-reviews-swiper', Object.assign({}, swiperOptions, {
                        loop: false,
                        spaceBetween: 24,
                        navigation: { nextEl: '.client-reviews-next', prevEl: '.client-reviews-prev' },
                        pagination: {
                            el: '.client-reviews-pagination',
                            clickable: true,
                            renderBullet: function(index, className) {
                                return '<span class="' + className + ' min-w-3 min-h-3 rounded-full bg-[#D9D9D9] cursor-pointer transition-colors duration-300"></span>';
                            }
                        }
                    }));
                }
            }
        }
    }

    function initVisibleTabSwiper() {
        var activeTab = document.querySelector('.testimonial-tab-content:not(.hidden)');
        if (activeTab) {
            var tabId = activeTab.getAttribute('id');
            if (tabId === 'video-tab') initSwipersIfNeeded('video');
            else if (tabId === 'reviews-tab') initSwipersIfNeeded('reviews');
        }
    }

    if (typeof Swiper !== 'undefined') {
        setTimeout(initVisibleTabSwiper, 100);
    } else {
        var checkSwiper = setInterval(function() {
            if (typeof Swiper !== 'undefined') {
                clearInterval(checkSwiper);
                setTimeout(initVisibleTabSwiper, 100);
            }
        }, 100);
    }

    tabButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            var targetTab = this.getAttribute('data-tab');
            var tabSpan = this.querySelector('span');

            tabButtons.forEach(function(btn) {
                btn.classList.remove('active', 'border-[#F79C53]');
                var span = btn.querySelector('span');
                if (span) {
                    span.classList.remove('text-primary', 'border-[#F79C53]');
                    span.classList.add('text-gray-400');
                }
            });

            tabContents.forEach(function(content) {
                content.classList.add('hidden');
            });

            this.classList.add('active', 'border-[#F79C53]');
            if (tabSpan) {
                tabSpan.classList.remove('text-gray-400');
                tabSpan.classList.add('text-primary');
            }

            var targetContent = document.getElementById(targetTab + '-tab');
            if (targetContent) {
                targetContent.classList.remove('hidden');
                setTimeout(function() {
                    if (targetTab === 'video') {
                        if (videoSwiper) videoSwiper.update();
                        else initSwipersIfNeeded('video');
                    } else if (targetTab === 'reviews') {
                        if (reviewsSwiper) reviewsSwiper.update();
                        else initSwipersIfNeeded('reviews');
                    }
                }, 150);
            }
        });
    });

    // Set first tab as active by default
    var firstButton = tabButtons[0];
    if (firstButton) {
        var firstTab = firstButton.getAttribute('data-tab');
        var firstTabSpan = firstButton.querySelector('span');
        var firstContent = document.getElementById(firstTab + '-tab');

        firstButton.classList.add('active', 'border-[#F79C53]');
        if (firstTabSpan) {
            firstTabSpan.classList.remove('text-gray-400');
            firstTabSpan.classList.add('text-primary');
        }
        if (firstContent) {
            firstContent.classList.remove('hidden');
            setTimeout(function() {
                if (firstTab === 'video') initSwipersIfNeeded('video');
                else if (firstTab === 'reviews') initSwipersIfNeeded('reviews');
            }, 200);
        }
    }
}

